import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { IUserAccount } from "../../infrastructure/userAccount";
import { ITagObject } from "../../entities/tag-object";

interface IRoleObject {
    text: string;
}

@Component
export default class UserEditor extends Vue {


    @Prop()
    mode: "edit" | "create";

    @Prop()
    value: IUserAccount;

    userGroupTag: string = "";
    userGroupTags: Array<ITagObject> = [];

    userRole: string = "";
    userRoles: Array<IRoleObject> = [];

    @Watch("value.userGroups")
    userGroupsChanged(data: string[]) {
        this.userGroupTags = data.map(p => {
            return { text: p }
        });

    }

    @Watch("value.roles")
    rolesChanged(data: string) {
        this.userRoles = data.split(",").map(p => ({ text: p }));

    }

    getSaveButtonText() {
        return this.mode === "create" ? "Register" : "Save";
    }

    onSaveClick() {
        this.value.userGroups = this.userGroupTags.map(p => p.text)
        this.value.roles = this.userRoles.map(p => p.text).join(",");
        this.$emit("saveClicked", this.value);
    }


    onCancelClick() {
        this.$emit("cancelClicked", "cancel");
    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/accounts/user-editor.ts